export enum PositionStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
}
